import icons from './icons.json'

export const gadget: BenefitStoreContext[string] = {
	short_description: 'To do this, provide us with the details of gadgets you want covered.',
	description: 'This protects your devices against screen damages and liquid spills at ₦ of each device per year',
	gadget_types: [
		{
			label: 'Mobile Phone',
			value: 'phone',
			rate: 5
		},
		{
			label: 'Laptop',
			value: 'laptop',
			rate: 3
		},
		{
			label: 'Tablet',
			rate: 5,
			value: 'tablet'
		}
	],
	product_title: 'Secure your work devices from damage',
	card_label:
		"Coverage for work devices at  <span class='font-semibold text-gray-500'> mcg_price value </span>, includes screen repairs, OEM parts replacement, and irreparable damage replacement.",
	dialogLabels: {
		addToPlan: {
			title: 'Add gadget policy holder',
			description: 'Select a method to add your gadget policy holder',
			options: {
				batch: { title: 'Batch Upload', description: 'Upload your gadget policy holders via an Excel sheet' },
				manual: { title: 'Manual Upload', description: 'Enter your gadget policy holders manually' }
			}
		},
		removeFromPlan: {
			title: 'Remove gadget',
			description: 'Select a method to remove gadgets from your plan',
			options: {
				batch: {
					title: 'Batch Removal',
					description: 'Upload the list of gadgets to remove via an Excel sheet.'
				},
				manual: {
					title: 'Manual Removal',
					description: 'Select the gadgets to remove'
				}
			}
		}
	},
	short_benefits: {
		'Need To Know': {
			icon: icons.need_to_know,
			isOpen: true,
			value: [
				'You can access claims under this coverage, but the total cannot exceed the insured sum.',
				"There are no excess deductions on this policy. You won't need to pay anything out-of-pocket to have your gadget repaired under a claim.",
				'This plan covers for burglary, theft, screen damage and liquid spills (theft excluded for individuals).',
				'You must conduct a pre-loss inspection for your gadget to be fully insured.'
			]
		},
		'How to get covered': {
			icon: icons.get_covered_icon,
			isOpen: false,
			value: [
				'Purchase a gadget cover.',
				'Submit all necessary information and documents.',
				'Activate your policy with your gadget details to receive your insurance certificate.',
				'Conduct a pre-loss inspection to be fully covered.'
			]
		},
		'How to claim': {
			icon: icons.claim,
			isOpen: false,
			value: [
				'Report your claim, with details of the incident.',
				'Conduct post-loss inspection.',
				'Submit a repair estimate.',
				'Receive and accept your claim offer once your claim is approved.'
			]
		},
		'Your Business Will Enjoy': {
			isOpen: false,
			icon: icons.business,
			value: [
				'Protection against Liquid and screen damage for insured gadgets, including OEM parts.',
				'Coverage for screen fixes or replacement, in the case of damage.',
				'Possible full replacement when it gets broken beyond repair.',
				'Direct payout amount for claim offers.',
				'You can access claims under this coverage, but the total cannot exceed the insured sum.'
			]
		}
	},
	allBenefits: {
		dialog: {
			benefits: [
				'Protection against Liquid and screen damage for insured gadgets, including OEM parts.',
				'Coverage for screen fixes or replacement, in the case of damage.',
				'Possible full replacement when it gets broken beyond repair.',
				'Direct payout amount for claim offers.',
				'You can access claims under this coverage, but the total cannot exceed the insured sum.'
			],
			need_to_know: [
				'You can access claims under this coverage, but the total cannot exceed the insured sum.',
				"There are no excess deductions on this policy. You won't need to pay anything out-of-pocket to have your gadget repaired under a claim.",
				'This plan covers for burglary, theft, screen damage and liquid spills (theft excluded for individuals).',
				'You must conduct a pre-loss inspection for your gadget to be fully insured.'
			],
			'How to get covered': [
				'Purchase a gadget cover.',
				'Submit all necessary information and documents.',
				'Activate your policy with your gadget details to receive your insurance certificate.',
				'Conduct a pre-loss inspection to be fully covered.'
			],
			'How to claim': [
				'Report your claim, with details of the incident.',
				'Conduct post-loss inspection.',
				'Submit a repair estimate.',
				'Receive and accept your claim offer once your claim is approved.'
			]
		}
	}
}

export const laptopCover: BenefitStoreContext[string] = {
	short_description: 'To do this, provide us with the details of gadgets you want covered.',
	description: 'This protects your devices against screen damages and liquid spills at ₦ of each device per year',
	product_title: 'Secure your work devices from damage',
	card_label:
		"Protect your business laptops against damage, theft, and essential repairs for just <span class='font-semibold text-gray-500'> mcg_price of the device's value annually </span>",
	dialogLabels: {
		addToPlan: {
			title: 'Add gadget policy holder',
			description: 'Select a method to add your gadget policy holder',
			options: {
				batch: { title: 'Batch Upload', description: 'Upload your gadget policy holders via an Excel sheet' },
				manual: { title: 'Manual Upload', description: 'Enter your gadget policy holders manually' }
			}
		},
		removeFromPlan: {
			title: 'Remove gadget',
			description: 'Select a method to remove gadgets from your plan',
			options: {
				batch: {
					title: 'Batch Removal',
					description: 'Upload the list of gadgets to remove via an Excel sheet.'
				},
				manual: {
					title: 'Manual Removal',
					description: 'Select the gadgets to remove'
				}
			}
		}
	},

	short_benefits: {
		'Need To Know': {
			icon: icons.need_to_know,
			isOpen: true,
			value: [
				'One-month waiting period for secondary benefits: Coverage for charging ports, chargers, and keyboards begins after one month if the laptops have been purchased for at least one month at the time of policy activation.',
				'Claim limits: Each business can initiate a maximum of two claims annually under this plan.',
				'Secondary benefits cap: Coverage for charging ports, chargers, and keyboards cannot exceed 50% of the device’s insured value annually.',
				'Pre-loss inspection required: All devices must undergo an inspection before insurance activation to verify their condition.',
				'Minimum requirement: Your business must insure a minimum of five devices to be eligible for the Standard Plan.'
			]
		},
		'Your Business Will Enjoy': {
			isOpen: false,
			icon: icons.business,
			value: [
				'Protection against accidental screen damage for insured laptops, including repairs or replacement using OEM parts.',
				'Coverage for liquid damage, ensuring repairs or replacements are handled promptly for spilled liquid incidents.',
				'Theft protection, providing coverage for the replacement of stolen laptops.',
				'Charging port, charger, and keyboard coverage, ensuring repairs or replacements for these components when necessary.',
				'Direct payout offers for approved claims, making it easier to manage repairs or replacements.',
				'Comprehensive coverage at a premium of 7% of the device’s value annually.'
			]
		},
		'How to get covered': {
			icon: icons.get_covered_icon,
			isOpen: false,
			value: [
				'Purchase a laptop cover by opting for the Standard Plan.',
				'Submit all required information and documents for the laptops you wish to insure.',
				'Activate your policy by providing detailed information about each device and receive your insurance certificate.',
				'Conduct a pre-loss inspection for all laptops to ensure they are in good condition before the policy becomes active.'
			]
		},
		'How to claim': {
			icon: icons.claim,
			isOpen: false,
			value: [
				'Report your claim with detailed information about the incident (e.g., theft, liquid damage, or component failure).',
				'Conduct a post-loss inspection of the affected device(s).',
				'Submit a repair estimate from an authorized service provider.',
				'Receive and accept your claim offer once your claim is reviewed and approved.'
			]
		}
	},
	allBenefits: {
		dialog: {
			benefits: [
				'Protection against accidental screen damage for insured laptops, including repairs or replacement using OEM parts.',
				'Coverage for liquid damage, ensuring repairs or replacements are handled promptly for spilled liquid incidents.',
				'Theft protection, providing coverage for the replacement of stolen laptops.',
				'Charging port, charger, and keyboard coverage, ensuring repairs or replacements for these components when necessary.',
				'Direct payout offers for approved claims, making it easier to manage repairs or replacements.',
				'Comprehensive coverage at a premium of 7% of the device’s value annually.'
			],
			need_to_know: [
				'One-month waiting period for secondary benefits: Coverage for charging ports, chargers, and keyboards begins after one month if the laptops have been purchased for at least one month at the time of policy activation.',
				'Claim limits: Each business can initiate a maximum of two claims annually under this plan.',
				'Secondary benefits cap: Coverage for charging ports, chargers, and keyboards cannot exceed 50% of the device’s insured value annually.',
				'Pre-loss inspection required: All devices must undergo an inspection before insurance activation to verify their condition.',
				'Minimum requirement: Your business must insure a minimum of five devices to be eligible for the Standard Plan.'
			],
			'How to get covered': [
				'Purchase a laptop cover by opting for the Standard Plan.',
				'Submit all required information and documents for the laptops you wish to insure.',
				'Activate your policy by providing detailed information about each device and receive your insurance certificate.',
				'Conduct a pre-loss inspection for all laptops to ensure they are in good condition before the policy becomes active.'
			],
			'How to claim': [
				'Report your claim with detailed information about the incident (e.g., theft, liquid damage, or component failure).',
				'Conduct a post-loss inspection of the affected device(s).',
				'Submit a repair estimate from an authorized service provider.',
				'Receive and accept your claim offer once your claim is reviewed and approved.'
			]
		}
	}
}
